import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { IconName } from 'icon/types'
import { observer } from 'mobx-react-lite'
import css from 'page/catalog/Circle/Circle.module.scss'
import { useEffect, useState } from 'react'

type Props = {
  image?: string
  icon?: IconName
  size?: number
}

export const Circle = observer((props: Props) => {
  const { image, icon } = props
  const size = props.size ?? 32
  const [error, setError] = useState(false)
  const show = !error && image

  useEffect(() => setError(false), [image])

  const onError = useLatestCallback(() => setError(true))

  return <Space className={css.circle} width={size} height={size} center>
    {show && <Image className={css.image} src={image} onError={onError} />}
    {!show && icon && <Icon name={icon} size={size / 2} secondary />}
  </Space>
})
